import { render } from "./SystemAdmin16.vue?vue&type=template&id=108d8a7d"
import script from "./SystemAdmin16.vue?vue&type=script&lang=js"
export * from "./SystemAdmin16.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__